import Http from "./http";

export const createEmailTemplateAPI = (data, options) => {
  return Http.post("admin/email-templates/createTemplate", data, options);
};
